export const keysToRemove = ['userInfo', 'appointmentAvailability','zohoClientId', 'DoctorAppointmentData'];

export const reproductiveGeneralInfo = "In this survey, trying to conceive means engaging in regular, unprotected sex without any form of birth control or preventative measures to avoid pregnancy."

export const reproductiveGeneralHeading = "Reproductive Health Assessment"

export const backBtnTxt = "Back"

export const exitBtnTxt = "Exit"

export const submitBtn = "Submit"

export const saveAndContinueBtn = "Save & Continue"